export namespace FormatUtils {
  export const formatCurrency = (value: number) =>  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);

  export const formatDate = (value: string) =>
    value ? new Date(value).toLocaleDateString('pl-PL') : '';
}